import { queryKeys } from '@/lib/query-keys';
import { orderClient } from '@/lib/api/ts-rest';
import type { Order } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';
import { useCurrentOrganization } from './useOrganization';

export const useOrders = () => {
  const { data: organization } = useCurrentOrganization();

  return useQuery<Order[], Error>({
    queryKey: queryKeys.orders.list(organization?.id),
    queryFn: async () => {
      if (!organization) {
        throw new Error('No organization selected');
      }
      const res = await orderClient.listMyOrders({
        query: { organizationId: organization.id },
      });
      if (res.status !== 200) throw new Error('Failed to load orders');
      return res.body;
    },
    enabled: !!organization,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    staleTime: 0,
  });
};
